import React from "react";
import styles from "./DressingChangeFrequency.module.scss";
import editIcon from "../../../../static/images/edit-icon-blue.png";
import { signedLockedAccess } from "../../../../utils";
import { CANCEL_BTN, CANCEL_ID, EDIT, SAVE_BTN, SUBMIT_ID } from "../../../../constants";
import { useDressingChangeFrequency } from "./hooks/useDressingChangeFrequency";
import ConfirmationModal from "../../../secondary/ConfirmationModal/ConfirmationModal";
import { Button, Form } from "../../../primary";
import { DressingChangeFrequencyItem } from "./DressingChangeFrequencyItem";

const CONFIRMATION_MESSAGE = "All progress in this section will be lost. Are you sure want to cancel?";

const EditIcon = ({ editable, assessmentDetails, onEdit }) => {
  if (editable || !signedLockedAccess(assessmentDetails?.assessmentStage)) return null;
  return (
    <div className={styles.edit_icon}>
      <span className={`float-sm-right ${styles.tab_edit} handleEdit`} onClick={onEdit}>
        <img src={editIcon} alt="edit" />
        {EDIT}
      </span>
    </div>
  );
};

export const DressingChangeFrequency = ({ interventionId, assessmentDetails }) => {
  const hook = useDressingChangeFrequency({ interventionId });

  const primaryItems = hook.dressChange?.data?.primary?.productCategory ?? [];
  const secondaryItems = hook.dressChange?.data?.secondary?.productCategory ?? [];
  const isEmpty = primaryItems.length === 0 && secondaryItems.length === 0;

  return (
    <>
      {hook.confirmationModal && (
        <ConfirmationModal message={CONFIRMATION_MESSAGE} onClose={hook.confirmationClose} onConfirm={hook.yesConfirmationModalClick} />
      )}

      <div className={`col-md-12 ${styles.treatment_container}`}>
        {isEmpty ? (
          <div className={styles.nodata_container}>There are no Primary / Secondary Dressing selected for this assessment</div>
        ) : (
          <Form
            setFormChangesConfirm={hook.setFormChangesConfirm}
            formChanges={true}
            className="col-12 p-0"
            onSubmit={hook.handleSubmit(hook.doSubmit)}
          >
            {/* Primary Dressing */}
            <div className={`col-12 ${styles.col_spec} d-flex mb-2`}>
              {primaryItems.length > 0 && !hook.editable && hook.hideButtons && (
                <EditIcon editable={hook.editable} assessmentDetails={assessmentDetails} onEdit={hook.handleEdit} />
              )}
              <label className="col-4 p-0">Primary Dressing:</label>
              <div className="col-8 mb-4 pb-1 p-0">
                {primaryItems.map((item, index) => (
                  <DressingChangeFrequencyItem
                    key={index}
                    item={item}
                    index={index}
                    type="primary"
                    editable={hook.editable}
                    numValidator={hook.numValidator}
                    onFrequencyChange={hook.getFrequency}
                    onFrequencyTypeChange={hook.getFrequencyType}
                  />
                ))}
              </div>
            </div>

            {/* Secondary Dressing */}
            <div className={`col-12 ${styles.col_spec} d-flex mb-2`}>
              {secondaryItems.length > 0 && !hook.editable && hook.hideButtons && (
                <EditIcon editable={hook.editable} assessmentDetails={assessmentDetails} onEdit={hook.handleEdit} />
              )}
              <label className="col-4 p-0">Secondary Dressing:</label>
              <div className="col-8 p-0">
                {secondaryItems.map((item, index) => (
                  <DressingChangeFrequencyItem
                    key={index}
                    item={item}
                    index={index}
                    type="secondary"
                    editable={hook.editable}
                    numValidator={hook.numValidator}
                    onFrequencyChange={hook.getFrequency}
                    onFrequencyTypeChange={hook.getFrequencyType}
                  />
                ))}
              </div>
            </div>

            {hook.editable && hook.hideButtons && (
              <div className="col-12 pt-2 mt-5 pl-1">
                <div className="offset-4">
                  <Button classes={{ className: `btn ${styles.btn_custom} ${styles.btn_small}` }} type="submit" id={SUBMIT_ID}>
                    {SAVE_BTN}
                  </Button>
                  <Button
                    type="button"
                    classes={{ className: `btn ${styles.btn_custom} ${styles.btn_small_cancel} handlecancel` }}
                    id={CANCEL_ID}
                    onClick={hook.handleCancel}
                  >
                    {CANCEL_BTN}
                  </Button>
                </div>
              </div>
            )}
          </Form>
        )}
      </div>
    </>
  );
};
